import React, { useState, useEffect } from "react";

import { Grid, FormControlLabel, Checkbox } from "@mui/material";

import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Brush,
} from "recharts";

export default function Assessments({ data, ...props }) {
  const [isWaterlowSelected, setIsWaterlowSelected] = useState(true);
  const [isMMSESelected, setIsMMSESelected] = useState(true);
  const [isFrailtySelected, setIsFrailtySelected] = useState(true);
  const [isBarthelSelected, setIsBarthelSelected] = useState(true);
  const [isMustSelected, setIsMustSelected] = useState(true);

  const [isAllSelected, setIsAllSelected] = useState(true);

  const [startIndex, setStartIndex] = useState(0);
  const [endIndex, setEndIndex] = useState(data.length - 1);

  useEffect(() => {
    const allSelected =
      isWaterlowSelected &&
      isMMSESelected &&
      isFrailtySelected &&
      isBarthelSelected &&
      isMustSelected;

    if (!allSelected) {
      setIsAllSelected(false);
    }
  }, [
    isWaterlowSelected,
    isMMSESelected,
    isFrailtySelected,
    isBarthelSelected,
    isMustSelected,
  ]);

  const handleZoom = (startIndex, endIndex) => {
    setStartIndex(startIndex);
    setEndIndex(endIndex);
  };

  const formatDate = (date) => {
    const options = { day: "2-digit", month: "2-digit", year: "numeric" };
    return new Intl.DateTimeFormat("en-GB", options).format(new Date(date));
  };

  const formatLabelDate = (value) =>
    new Date(value).toLocaleString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });

  const setAllSelected = (value) => {
    if (value) {
      setIsWaterlowSelected(true);
      setIsMMSESelected(true);
      setIsFrailtySelected(true);
      setIsBarthelSelected(true);
      setIsMustSelected(true);
      setIsAllSelected(true);
    } else {
      setIsWaterlowSelected(false);
      setIsMMSESelected(false);
      setIsFrailtySelected(false);
      setIsBarthelSelected(false);
      setIsMustSelected(false);
      setIsAllSelected(false);
    }
  };

  return (
    <div>
      <Grid
        container
        spacing={1}
        style={{ display: "flex", alignItems: "center" }}
      >
        <Grid
          item
          xs={12}
          md={12}
          style={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <FormControlLabel
            control={
              <Checkbox
                checked={isWaterlowSelected}
                onChange={(e) => setIsWaterlowSelected(e.target.checked)}
                name="waterlow"
                color="primary"
              />
            }
            label="Waterlow"
          />

          <FormControlLabel
            control={
              <Checkbox
                checked={isMMSESelected}
                onChange={(e) => setIsMMSESelected(e.target.checked)}
                name="mmse"
                color="primary"
              />
            }
            label="MMSE"
          />

          <FormControlLabel
            control={
              <Checkbox
                checked={isFrailtySelected}
                onChange={(e) => setIsFrailtySelected(e.target.checked)}
                name="frailty"
                color="primary"
              />
            }
            label="Frailty"
          />

          <FormControlLabel
            control={
              <Checkbox
                checked={isBarthelSelected}
                onChange={(e) => setIsBarthelSelected(e.target.checked)}
                name="barthel"
                color="primary"
              />
            }
            label="Barthel"
          />

          <FormControlLabel
            control={
              <Checkbox
                checked={isMustSelected}
                onChange={(e) => setIsMustSelected(e.target.checked)}
                name="must"
                color="primary"
              />
            }
            label="MUST"
          />

          <FormControlLabel
            control={
              <Checkbox
                checked={isAllSelected}
                onChange={(e) => setAllSelected(e.target.checked)}
                name="all_selected"
                color="primary"
              />
            }
            label="All"
          />
        </Grid>
      </Grid>

      <ResponsiveContainer width="100%" height={700}>
        <LineChart
          data={data}
          margin={{ top: 0, left: 65, right: 125, bottom: 0 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="timestamp" tickFormatter={formatDate} />
          <YAxis />
          <Tooltip labelFormatter={formatLabelDate} />
          <Legend
            verticalAlign="top"
            layout="horizontal"
            wrapperStyle={{ padding: 20 }}
            //margin={[10, 0, 10, 0]}
          />

          {isWaterlowSelected && (
            <Line
              type="monotone"
              connectNulls
              dataKey="waterlow_total_score"
              stroke="#555498"
              name="Waterlow"
            />
          )}

          {isMMSESelected && (
            <Line
              type="monotone"
              connectNulls
              dataKey="mmse_total_score"
              stroke="#6d4f7d"
              name="MMSE"
            />
          )}

          {isFrailtySelected && (
            <Line
              type="monotone"
              connectNulls
              dataKey="frailty_total_score"
              stroke="#0bb3f1"
              name="Frailty"
            />
          )}

          {isBarthelSelected && (
            <Line
              type="monotone"
              connectNulls
              dataKey="barthel_total_score"
              stroke="#d76532"
              name="Barthel"
            />
          )}

          {isMustSelected && (
            <Line
              type="monotone"
              connectNulls
              dataKey="must_total_score"
              stroke="#018599"
              name="MUST"
            />
          )}

          <Brush
            stroke="#000"
            fill="#C2D1C0"
            dataKey="timestamp"
            height={35}
            //width={200}
            startIndex={startIndex}
            endIndex={endIndex}
            tickFormatter={formatLabelDate}
            alwaysShowText={true}
            onChange={({ startIndex, endIndex }) =>
              handleZoom(startIndex, endIndex)
            }
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
